import { useFragment, type FragmentType } from "@repo/graphql-types";
import { graphql } from "@repo/graphql-types";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { ButtonTabs } from "@/components/button-tabs";
import { PatientDetailPropertyList } from "@/components/patient-detail-property-list";
import { PatientHistoryList } from "@/components/patient-history-list";

export const PatientDetailTabsFragment = graphql(/* GraphQL */ `
  fragment PatientDetailTabsFragment on pacientes {
    ...PatientDetailPropertyListFragment
    ...PatientHistoryListFragment
    codPaciente
  }
`);

interface PatientDetailTabsProps {
  data: FragmentType<typeof PatientDetailTabsFragment>;
}

export const PatientDetailTabs = ({ data }: PatientDetailTabsProps): JSX.Element => {
  const { activeTab = "dados-do-paciente" } = useSearch({
    from: "/patients/$patientId/",
  });

  const navigate = useNavigate();

  const fragmentData = useFragment(PatientDetailTabsFragment, data);

  const tabs = [
    { id: "dados-do-paciente", label: "Dados do paciente" },
    { id: "agendamentos", label: "Agendamentos" },
  ];

  const handleTabChange = (id: string): void => {
    void navigate({
      to: "/patients/$patientId/",
      params: { patientId: String(fragmentData.codPaciente) },
      search: { activeTab: id },
      replace: true,
    });
  };

  return (
    <div>
      <ButtonTabs
        activeTab={String(activeTab)}
        onTabChange={handleTabChange}
        tabs={tabs}
      />

      {activeTab === "dados-do-paciente" && (
        <div className="-mt-4">
          <PatientDetailPropertyList patient={fragmentData} title="" />
        </div>
      )}

      {activeTab === "agendamentos" && (
        <PatientHistoryList patient={fragmentData} title="" />
      )}
    </div>
  );
};
